
  import { defineComponent } from 'vue';
  import { DropdownField } from '@/ui/components/form/DropdownField';
  import { countries } from 'countries-list';

  interface CbCountrySelectProps {
    country: string;
    currency: string;
  }

  export default defineComponent<CbCountrySelectProps>({
    name: 'CbCountrySelect',
    components: {
      DropdownField,
    },
    props: ['country', 'currency'],
    setup(props, context) {
      const countryList = Object.entries(countries).map(([countryCode, country]) => ({
        label: country.name,
        value: countryCode,
      }));
      const onCountryChange = (v: string) => {
        context.emit('countryChange', v);
      };

      return {
        countryList,
        onCountryChange,
      };
    },
  });
